import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import { FiberManualRecord } from '@material-ui/icons'
import cn from 'classnames'
import {
  deleteJobInputItem,
  jobInputsClearStore,
  fetchJobInputPositionUpdate,
  fetchJobInputData,
} from 'reducers/jobInputsAdmin/reducer'
import {
  JOBS_WORKFLOW_ADMIN,
  JOB_WORKFLOW_INPUT_ITEMS,
} from 'constants/appRouting'
import * as ROUTE from 'constants/appRouting'
import Column from 'types/table/Column'
import Action from 'types/table/Action'
import ListFromTable from 'components/common/ListFromTable'
import ColumnCollection from 'types/table/ColumnCollection'
import ActionCollection from 'types/table/ActionCollection'
import UrlHelper from 'helpers/url'
import JobsWorkflowAdminPositionChange from '../JobsWorkflowAdminPositionChange'
import messages from '../translate'

class JobInputList extends ListFromTable {
  constructor(props) {
    super(props)
    this.asyncData = true
    this.loadingData = true
    this.getTableData = this.getInputsTableData
    this.clearReducerState = props.jobInputsClearStore

    this.state = {
      isDenseRows: false,
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { backUrlParams } = this.state
    const {
      loader,
      location: { search },
    } = nextProps
    const queryParams = new URLSearchParams(search)
    const backParams = queryParams.get('backUrlParams')

    this.loadingData = loader

    if (search && search.length && backParams && !backUrlParams) {
      this.setState({
        backUrlParams: backParams,
      })
    }

    return super.shouldComponentUpdate(nextProps, nextState)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
      history: { push },
      location: { search },
    } = this.props
    const { isDenseRows, backUrlParams } = this.state
    let backUrl = JOBS_WORKFLOW_ADMIN
    let title

    if (search && search.length) {
      const queryParams = new URLSearchParams(search)

      title = `${queryParams.get('jobTitle')} | ${queryParams.get(
        'taskTitle',
      )} | ${queryParams.get('inputGroupTitle')}`
      backUrl = JOB_WORKFLOW_INPUT_ITEMS
    } else {
      title = formatMessage(messages.jobInputsList)
    }

    if (backUrlParams && backUrlParams.length) {
      backUrl = `${JOB_WORKFLOW_INPUT_ITEMS}${backUrlParams}`
    }

    return {
      goBack: () => {
        push(backUrl)
      },
      title,
      className: 'job-inputs-table',
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
      dense: {
        enabled: true,
        state: isDenseRows,
        handler: () => this.handleChangeDense(),
      },
    }
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteJobInput),
      message: formatMessage(messages.deleteJobInputMessage),
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
      location: { search },
    } = this.props
    let searchParams

    if (search && search.length) {
      const incomingParams = new URLSearchParams(search)
      const newParams = new URLSearchParams()

      newParams.append('taskTitle', incomingParams.get('taskTitle'))
      newParams.append('jobTitle', incomingParams.get('jobTitle'))
      newParams.append('inputGroupTitle', incomingParams.get('inputGroupTitle'))
      searchParams = newParams.toString()
    }

    return {
      title: formatMessage(messages.createJobInput),
      link: ROUTE.JOB_WORKFLOW_INPUTS_CREATE,
      params: searchParams,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
      fetchJobInputPositionUpdate,
    } = this.props
    const columns = new ColumnCollection()

    columns.add(
      new Column('id', 'ID', {
        sorting: true,
      }),
    )
    columns.add(
      new Column('position', formatMessage(messages.position), {
        sorting: true,
        render: ({ position, id }, rowIndex) => {
          const handlePositionChange = position => {
            fetchJobInputPositionUpdate({
              params: {
                type: 'job-workflow-inputs',
                id,
              },
              data: {
                position,
              },
              index: rowIndex,
            })
          }

          return (
            <JobsWorkflowAdminPositionChange
              position={position}
              onChange={handlePositionChange}
            />
          )
        },
      }),
    )
    columns.add(
      new Column('title', formatMessage(messages.title), {
        sorting: true,
        render: ({ title }) => title,
      }),
    )
    columns.add(
      new Column('workflow_title', formatMessage(messages.workflowTitle), {
        sorting: true,
      }),
    )
    columns.add(
      new Column(
        'workflow_task_title',
        formatMessage(messages.workflowTaskTitle),
        {
          sorting: true,
        },
      ),
    )
    columns.add(
      new Column('type', formatMessage(messages.inputType), {
        sorting: true,
      }),
    )
    columns.add(
      new Column('date_updated', formatMessage(messages.dateUpdated), {
        sorting: true,
        render: ({ date_updated }) => moment(date_updated).format('DD/MM/YYYY'),
      }),
    )
    columns.add(
      new Column('enabled', formatMessage(messages.active), {
        sorting: true,
        render: ({ enabled }) => (
          <FiberManualRecord
            className={cn('user-status-icon', { 'status-enabled': enabled })}
          />
        ),
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
      deleteJobInputItem,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('edit', formatMessage(messages.editJobInput), ({ id }) => {
        history.push(UrlHelper.create(ROUTE.JOB_WORKFLOW_INPUTS_EDIT, { id }))
      }),
    )
    actions.add(
      new Action('delete', formatMessage(messages.deleteJobInput), ({ id }) => {
        this.onOpenConfirmDialog(
          {
            entityId: id,
            entityType: 'inputGroup',
            psfs: this.psfs,
          },
          deleteJobInputItem,
        )
      }),
    )

    return actions
  }

  getInputsTableData() {
    const {
      fetchJobInputData,
      location: { search },
    } = this.props

    if (search && search.length) {
      const params = new URLSearchParams(search)

      this.psfs.addFilter('inputGroup', params.get('inputGroupId'))
    }

    fetchJobInputData({ psfs: this.psfs })
  }

  handleChangeDense() {
    this.setState(prevState => ({
      isDenseRows: !prevState.isDenseRows,
    }))
  }
}

JobInputList.propTypes = {
  tableData: PropTypes.object.isRequired,
  loader: PropTypes.bool.isRequired,
  fetchJobInputData: PropTypes.func,
  deleteJobInputItem: PropTypes.func,
  jobInputsClearStore: PropTypes.func,
}

JobInputList.defaultProps = {
  fetchJobInputData: () => {},
  deleteJobInputItem: () => {},
  jobInputsClearStore: () => {},
}

export default connect(
  state => ({
    tableData: state.getIn(['jobInputsAdmin', 'tableData']),
    loader: state.getIn(['jobInputsAdmin', 'isLoadingTableData']),
  }),
  {
    fetchJobInputData,
    deleteJobInputItem,
    jobInputsClearStore,
    fetchJobInputPositionUpdate,
  },
)(injectIntl(JobInputList))
